module.exports = __webpack_public_path__ + "img/text.dcc37b77.svg";